import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import AxiosApiClient from '../utils/AxiosApiClient';
import AuthUtility from './auth/AuthUtility';
import LoadingSpinner from './LoadingSpinner';

import $ from 'jquery'; // Import jQuery
import swal from 'sweetalert';

const error_style = 'font-source-sans font-size-12 font-weight-500 txt-red p-5';

function Contact() {

	const navHistory = useNavigate();

	//for all API calls
	const auth_api = 'phpLaravel';
	if (localStorage.getItem('auth_api') && localStorage.getItem('auth_api') !== '') {
		auth_api = localStorage.getItem('auth_api');
	}

	// using hooks
	const [isLoading, setIsLoading] = React.useState(false);
	const [contactInput, setContact] = useState({
		first_name: '',
		last_name: '',
		phone: '',
		email: '',
		option: 'prayer_request',
		message: '',
		errorList: [],
		errorStyle: [],
	});

	const handleInput = (event) => {
		event.persist();

		setContact({ ...contactInput, [event.target.name]: event.target.value });

		//remove the target error message no matter the new input, it will be validated on the server
		if (contactInput.errorList.hasOwnProperty(event.target.name)) {
			delete contactInput.errorList[event.target.name];
			delete contactInput.errorStyle[event.target.name];
			$('#' + event.target.name + '_message').removeClass('hide') //clear any previous message
		}
	}

	const contactSubmit = (event) => {
		event.preventDefault();

		setIsLoading(true);

		//values sent to api
		const payload = {
			first_name: contactInput.first_name,
			last_name: contactInput.last_name,
			email: contactInput.email,
			phone: contactInput.phone,
			option: contactInput.option,
			message: contactInput.message,
		}

		const fetchApiData = async () => {
			try {
				const { apiClient, getBearerToken, makeRequestWithHeaders } = AxiosApiClient({ apiBackend: auth_api, token: localStorage.getItem('auth_token') });
				await getBearerToken();
				const response = await makeRequestWithHeaders('post', '/api/contact', payload, {});

				setApiData(response, "contactSubmit");
			} catch (error) {
				handleApiError(error, "contactSubmit");
			}
		};

		fetchApiData();
	}
	function setApiData(response, theFunction) {
		if (response && response.data) {
			if (response.data.status === 200) {//HTTP_OK
				console.log(theFunction + ': ', response.data.api_message);

				//sweet alert on next page
				swal("Success", response.data.api_message, "success");
				navHistory('/');

			} else if (response.data.status === 401) {//HTTP_UNAUTHORIZED
				console.log(theFunction + ' error: ', response.data.message + ' back-end api call error');

				//user not authenticated on server so remove from local storage
				AuthUtility.clearAuthData();
				swal("Warning", response.data.message, "warning");
			} else if (response.data.status === 800) {//HTTP_FORM_VALIDATION_FAILED
				console.log(theFunction + ': ', response.data.message + ' HTTP_FORM_VALIDATION_FAILED');

				var errorStyleTemp = JSON.parse(JSON.stringify(response.data.validation_errors));
				Object.keys(errorStyleTemp).map((key) => (
					errorStyleTemp[key] = error_style
				));
				Object.keys(errorStyleTemp).map((key) => (
					$('#' + key + '_message').addClass('hide') //clear any previous message
				));

				//validation errors mapped to input fields
				setContact({ ...contactInput, errorList: response.data.validation_errors, errorStyle: errorStyleTemp });

			} else {//more errors
			}
		}

		setIsLoading(false);
	}
	function handleApiError(error, theFunction) {
		console.log(theFunction + ' error: ', error + ' back-end api call error');

		//user not authenticated on server so remove from local storage
		AuthUtility.clearAuthData();
		setIsLoading(false);
		swal("Error", error, "error");
	}

	return (

		<div className="grid-x bg-fafafa b1-ddd p-20l-10s">
			<div className="large-12 medium-12 small-12 cell">

				<form onSubmit={contactSubmit}>
					<div className="grid-x">
						<div className="font-libre-baskerville font-size-18l-16m font-weight-400 justify line-height-120per">
						We would love to hear from you. Whether you have a prayer request, a song suggestion, a story to share, or would like to connect with our ministry, we are here.
						</div>
						<div className="large-6 medium-6 small-12 cell text-left pr-5l-0s">
							<div className={contactInput.errorStyle.first_name}>{contactInput.errorList.first_name}</div>
							<div className="p-5" id="first_name_message">&nbsp;</div>
							<div className="input-group">
								<span className="input-group-label"><span className="fas fa-user txt-555"></span></span>
								<input type="text" name="first_name" onChange={handleInput} value={contactInput.first_name} className="input-group-fieldx" placeholder="First Name" />
							</div>
						</div>
						<div className="large-6 medium-6 small-12 cell text-left pl-5l-0s">
							<div className={contactInput.errorStyle.last_name}>{contactInput.errorList.last_name}</div>
							<div className="p-5" id="last_name_message">&nbsp;</div>
							<div className="input-group">
								<span className="input-group-label"><span className="fas fa-user txt-555"></span></span>
								<input type="text" name="last_name" onChange={handleInput} value={contactInput.last_name} className="input-group-field" placeholder="Last Name" />
							</div>
						</div>
						<div className="large-6 medium-6 small-12 cell text-left pr-5l-0s">
							<div className={contactInput.errorStyle.email}>{contactInput.errorList.email}</div>
							<div className="p-5" id="email_message">&nbsp;</div>
							<div className="input-group">
								<span className="input-group-label"><span className="fas fa-envelope txt-555"></span></span>
								<input type="text" name="email" onChange={handleInput} value={contactInput.email} className="input-group-field" placeholder="Email" />
							</div>
						</div>
						<div className="large-6 medium-6 small-12 cell text-left pl-5l-0s">
							<div className={contactInput.errorStyle.phone}>{contactInput.errorList.phone}</div>
							<div className="p-5" id="phone_message">&nbsp;</div>
							<div className="input-group">
								<span className="input-group-label"><span className="fas fa-lock txt-555"></span></span>
								<input type="text" name="phone" onChange={handleInput} value={contactInput.phone} className="input-group-field" placeholder="Phone" />
							</div>
						</div>
						<div className="large-6 medium-6 small-12 cell text-left pr-5l-0s">
							<div className={contactInput.errorStyle.option}>{contactInput.errorList.option}</div>
							<div className="p-5" id="option_message">&nbsp;</div>
							<div className="input-group">
								<span className="input-group-label"><span className="fas fa-lock txt-555"></span></span>
								<select	name="option" onChange={handleInput} value={contactInput.option}>
									<option key="1" value="prayer_request">Prayer Request</option>
									<option key="2" value="song_request">Song Request</option>
									<option key="3" value="podcast_request">Podcast Request</option>
									<option key="4" value="radio_show_interview_request">Radio Show Interview Request</option>
									<option key="5" value="share_my_story">Share My Story</option>
									<option key="6" value="encouragement_or_feedback">Encouragement or Feedback</option>
									<option key="7" value="general_question">General Question</option>
									<option key="8" value="other">Other</option>
								</select>
							</div>
						</div>
						<div className="large-12 medium-12 small-12 cell text-left">
							<div className={contactInput.errorStyle.message}>{contactInput.errorList.message}</div>
							<div className="p-5" id="message_message">&nbsp;</div>
							<div className="input-group">
								<textarea name="message" onChange={handleInput} value={contactInput.message} className="input-group-field" placeholder="Share your prayer request, message, story, song request, or how we can serve you." />
							</div>
						</div>
						<div className="large-12 medium-12 small-12 cell text-right">
							<div className="horizontal-container justify-right">
								{isLoading &&
									<span className="element pr-10">
										<LoadingSpinner paddingclassName="none" sizeclassName="none" />
									</span>
								}
								<span className="element">
									<button type="submit" className="button width-125px-100px">Submit</button>
								</span>
							</div>
						</div>
					</div>
				</form>

			</div>
		</div>
	);
}

export default Contact;